import "../styles/globals.scss";
import { Provider } from "react-redux";
import { useRouter } from "next/router";
import { store, persistor } from "@/app/store/index";
import { PersistGate } from "redux-persist/integration/react";
import dynamic from "next/dynamic";
import AppInitialize from "@/components/AppInitialize";
import { useEffect } from "react";
import getConfig from "next/config";
import { Inter } from "next/font/google";
import Head from "next/head";

const { publicRuntimeConfig } = getConfig();
const CURRENT_VERSION = publicRuntimeConfig.appVersion;


// Dynamically import the Component with SSR disabled
const NoSSRComponent = dynamic(() => import("@/components/NoSSR"), {
  ssr: false,
});

const inter = Inter({
  subsets: ["latin"],
  weight: ["400", "500", "700"],
  variable: "--font-inter",
});

export default function App({ Component, pageProps }) {
  const router = useRouter();
  console.log(router.asPath)
  const canonicalUrl = `${process.env.NEXT_PUBLIC_BLOGS_DOMAIN}${router.asPath}`;

  useEffect(() => {
    if (typeof window !== "undefined") {
      const savedVersion = localStorage.getItem("redux_version");
      if (savedVersion !== CURRENT_VERSION) {
        persistor.purge().then(() => {
          localStorage.setItem("redux_version", CURRENT_VERSION);
          console.log("Cleared persisted state due to version change.");
        });
      }
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppInitialize>
          <div className={inter.variable}>
          <Head>
        <link rel="canonical" href={canonicalUrl.split("?")[0]} />
        <meta name="robots" content="index, follow" />
      </Head>
            <Component {...pageProps} />
          </div>
        </AppInitialize>
      </PersistGate>
    </Provider>
  );
}